<template>
  <div class="page">
    <div class="app-container">
      <!-- <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch> -->
      <BaseTable
        ref="baseTable"
        url="/admin/set/salesPerson"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" size="mini" v-if="row.status == '待审核'" @click="handleRow(row, 'completed')">审核</el-button>
          <el-button type="text" size="mini" @click="handleRow(row, 'enabled')">修改状态</el-button>
        </template>
      </BaseTable>
      <!-- 审核 -->
      <el-dialog  title="修改状态" :visible.sync="CodeEnabledBefor" width="40%" @close="CodeEnabledBefor = false">
        <el-form inline ref="" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="状态" prop="status">
              <el-select v-model="is_enabled" filterable>
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeEnabledBefor = false">取消</el-button>
              <el-button size="mini" @click="setEnabled">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
      <!-- 审核 -->
      <el-dialog  title="审核" :visible.sync="CodeReviewBefor" width="40%" @close="CodeReviewBefor = false">
        <el-form inline ref="" label-width="150px" class="demo-ruleForm">
            <el-form-item class="from-item--30" label="审核" prop="status">
              <el-select v-model="status" filterable>
                <el-option label="通过" value="2"></el-option>
                <el-option label="不通过" value="3"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <div style="margin-left:50px;">
              <el-button size="mini" @click="CodeReviewBefor = false">取消</el-button>
              <el-button size="mini" @click="setReview">确定</el-button>
            </div>
          </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";
import { status } from "nprogress";

export default {
  name: "Log",
  comments: {},
  data() {
    return {
      tableData: [],
      searchData: {},
      CodeEnabledBefor:false,
      CodeReviewBefor:false,
      id:0,
      status:'',
      is_enabled:''
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {
    
  },
  methods: {
    handleRow(row, k) {
      switch (k) {
        case "detail":
          this.handleDetail(row);
          break;
        case "completed":
          this.handleCompleted(row);
          break;
        case "enabled":
          this.handleEnabled(row);
          break;    
        default:
          break;
        }
    },
    handleEnabled({ id }){
      this.id = id
      this.CodeEnabledBefor = true;
    },
    handleCompleted({ id }){
      this.id = id
      this.CodeReviewBefor = true;
    },
    setEnabled(){
      const res = this.$api.post("/admin/set/salesPersonsave", {
        id: this.id,
        is_enabled: this.is_enabled
      });
      this.CodeEnabledBefor = false;
      this.is_enabled = '';
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
    },
    setReview(){
      const res = this.$api.post("/admin/set/salesPersonsave", {
        id: this.id,
        status: this.status
      });
      this.CodeReviewBefor = false;
      this.status = '';
      let that = this;
      setTimeout(() => {
        that.handleSearch();
      }, 1000);
    },
    // 点击详情
    handleDetail({ id }) {
      this.$router.push({
        path: "/accident/detail",
        query: {
          id,
        },
      });
    },
    // 点击编辑
    handleEdit({ id }) {
      this.$router.push({
        path: "/accident/apply",
        query: {
          id,
        },
      });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>
